import { useCallback, useEffect } from "react"

import { PRINT_PAGE_ONLY_CLASS } from "../components/print/printPageOnly"

function togglePrintPageOnly(isEnabled: boolean) {
    document.documentElement.classList.toggle(PRINT_PAGE_ONLY_CLASS, isEnabled)
    document.body.classList.toggle(PRINT_PAGE_ONLY_CLASS, isEnabled)
}

function handleAfterPrint() {
    togglePrintPageOnly(false)
}

export function usePrintPageOnly() {
    useEffect(
        () => () => {
            window.removeEventListener("afterprint", handleAfterPrint)
            togglePrintPageOnly(false)
        },
        [],
    )

    return useCallback(() => {
        window.addEventListener("afterprint", handleAfterPrint, { once: true })
        togglePrintPageOnly(true)
        window.print()
    }, [])
}
